module.exports = __webpack_public_path__ + "media/10_ASANBudapest-Custom10.56773c9b.mp3";